import { render } from "./AddInventory.vue?vue&type=template&id=01468349&scoped=true"
import script from "./AddInventory.vue?vue&type=script&lang=js"
export * from "./AddInventory.vue?vue&type=script&lang=js"

import "./AddInventory.vue?vue&type=style&index=0&id=01468349&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01468349"]])

export default __exports__